import { render, staticRenderFns } from "./ThreadOpen.vue?vue&type=template&id=23fc3083"
import script from "./ThreadOpen.vue?vue&type=script&lang=js"
export * from "./ThreadOpen.vue?vue&type=script&lang=js"
import style0 from "./ThreadOpen.vue?vue&type=style&index=0&id=23fc3083&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports